/** Texts of the personal signature (docs/architecture/signatures.md). */
export const signatureDe = {
  title: 'Unterschrift',
  description:
    'Für Berichte und Protokolle: Dokumente setzen die Unterschrift mit Name und Funktion ein.',
  current: 'Hinterlegte Unterschrift',
  none: 'Noch keine Unterschrift hinterlegt.',
  unused:
    'Unterschriften brauchen das Recht, Dokumente zu erzeugen. Die hinterlegte Unterschrift lässt sich löschen.',
  preview: 'Hinterlegte Unterschrift',
  add: 'Unterschrift hinterlegen',
  change: 'Unterschrift ändern',
  delete: 'Unterschrift löschen',
  deleteTitle: 'Unterschrift löschen?',
  deleteDescription: 'Bild und Funktion werden gelöscht.',
  deleted: 'Unterschrift gelöscht',
  saved: 'Unterschrift gespeichert',
  role: 'Funktion',
  roleHint: 'Steht unter der Unterschrift, z. B. „Brandschutzbeauftragte“.',
  roleSaved: 'Funktion gespeichert',
  dialog: {
    title: 'Unterschrift hinterlegen',
    description:
      'Mit Finger, Stift oder Maus im Feld unterschreiben oder ein Bild der Unterschrift hochladen.',
    pad: 'Feld zum Unterschreiben',
    clear: 'Neu beginnen',
    upload: 'Bild hochladen',
    uploadHint: 'PNG, JPEG oder WebP bis 10 MB. Ein weißer Hintergrund wird transparent.',
    uploaded: 'Unterschrift aus dem hochgeladenen Bild',
    draw: 'Stattdessen zeichnen',
    missing: 'Bitte im Feld unterschreiben oder ein Bild hochladen.',
    save: 'Speichern',
  },
  upload: {
    type: 'Nur Bilder im Format PNG, JPEG oder WebP.',
    size: 'Das Bild ist größer als 10 MB.',
    decode: 'Das Bild lässt sich nicht lesen. Bitte ein anderes wählen.',
    empty:
      'Auf dem Bild ist keine Unterschrift zu erkennen. Am besten eignet sich dunkle Schrift auf weißem Papier.',
  },
  errors: {
    format: 'Das Bild ist kein gültiges PNG.',
    size: 'Das Bild ist größer als 500 KB.',
    dimensions: 'Das Bild ist größer als 2000 × 1000 Pixel.',
    forbidden:
      'Eine Unterschrift lässt sich nur mit dem Recht hinterlegen, Dokumente zu erzeugen, und nur in der eigenen Firma.',
  },
};
